var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { GoalStatus } from 'globals/enums';
var STATUS_PRIORITY = (_a = {},
    _a[GoalStatus.Started] = 1,
    _a[GoalStatus.In_Progress] = 1,
    _a[GoalStatus.Not_Started] = 1,
    _a[GoalStatus.Completed] = 2,
    _a[GoalStatus.Cancelled] = 3,
    _a[GoalStatus.Deleted] = 4,
    _a);
export var sortGoals = function (data) {
    return __spreadArray([], data, true).sort(function (a, b) {
        var _a, _b, _c, _d;
        var isEmptyA = !a.goal && !a.action;
        var isEmptyB = !b.goal && !b.action;
        if (isEmptyA !== isEmptyB)
            return isEmptyA ? -1 : 1;
        if (!!a.isNewGoal !== !!b.isNewGoal) {
            return a.isNewGoal ? -1 : 1;
        }
        var statusA = (_a = STATUS_PRIORITY[a.status]) !== null && _a !== void 0 ? _a : 99;
        var statusB = (_b = STATUS_PRIORITY[b.status]) !== null && _b !== void 0 ? _b : 99;
        if (statusA !== statusB)
            return statusA - statusB;
        var dateA = new Date((_c = a.createdDate) !== null && _c !== void 0 ? _c : 0).getTime();
        var dateB = new Date((_d = b.createdDate) !== null && _d !== void 0 ? _d : 0).getTime();
        return dateB - dateA;
    });
};
